import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { MuiThemeProvider } from 'material-ui/styles'
import RefreshIndicator from 'material-ui/RefreshIndicator'
import SnackBar from '../Common/Snackbar'

// Import can't be in conditional so use require.
if (process.env.WEBPACK) {
  require('./App.css') // eslint-disable-line global-require
}
const style = {
  loaderBackdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    backgroundColor: 'rgba(10, 10, 10, 0.35)',
    zIndex: 1650,
    cursor: 'progress'
  },
  span: {
    color: 'rgb(255, 64, 129)' // 'rgb(0, 188, 212)'
  },
  loaderBox: {
    position: 'absolute',
    top: '50%',
    left: '50%'
  }
}

const mapStateToProps = state => ({
  messages: state.loadingMessages,
  counter: state.counter
})

class App extends Component {
  render() {
    const { children, counter, messages } = this.props
    return (
      <MuiThemeProvider>
        <div className='App'>
          {this.props.children}
          {counter > 0 ? (
            <div style={style.loaderBackdrop}>
              <div style={style.loaderBox}>
                <RefreshIndicator
                  size={40}
                  left={10}
                  top={0}
                  status='loading'
                />
                {/* <span style={style.span}>{messages[0]}</span> */}
              </div>
            </div>
          ) : (
            ''
          )}
          <SnackBar />
        </div>
      </MuiThemeProvider>
    )
  }
}
/*
const App = props => (

  <MuiThemeProvider>
    <div className="App">
      {props.children}
      <div style={style.loader}>
        <div style={style.loaderBox}>
          <RefreshIndicator
            size={40}
            left={10}
            top={0}
            status="loading"
            style={style.refresh}
          />
        </div>
      </div>
    </div>
  </MuiThemeProvider>
);
*/
App.propTypes = {
  children: PropTypes.node
}

// export default App;
export default connect(mapStateToProps)(App)



/** WEBPACK FOOTER **
 ** ./src/components/App/App.js
 **/